import React, { useState } from "react";

import Drawer from "@mui/material/Drawer";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  animate: {
    animation: `$fade-in-keyframes 0.12s`,
    animationIterationCount: 4,
  },
  "@keyframes fade-in-keyframes": {
    "0%": { boxShadow: "rgba(0, 0, 0, 0.75) 0px 5px 10px" },
    "50%": { boxShadow: "rgba(0, 0, 0, 0.75) 0px 5px 30px" },
    "100%": { boxShadow: "none" },
  },
});

const KMKDrawer = (props) => {
  const { classes } = useStyles();
  const [animate, setAnimate] = useState(false);

  return (
    <Drawer
      classes={{
        paper: animate ? classes.animate : "",
      }}
      onClose={() => setAnimate(true)}
      onAnimationEnd={() => setAnimate(false)}
      {...props}
    >
      {props.children}
    </Drawer>
  );
};

export default React.memo(KMKDrawer);
